/**
 * Feature Flags pour activation progressive
 * Phase 1 + 2 : React Query + Realtime avec garde-fous
 */
export const FEATURES = {
  // Phase 1 : Refetch automatique React Query
  REACT_QUERY_REFETCH: true, // ✅ Activé pour Realtime
  
  // Phase 2 : Realtime Supabase
  REALTIME_ENABLED: true, // ✅ Réactivé après corrections DB et architecture
  
  // Fallback polling (toujours actif)
  POLLING_FALLBACK: true, // ✅ Toujours actif
  
  // Debug
  SHOW_QUERY_DEVTOOLS: true, // Afficher React Query Devtools
  SHOW_REALTIME_MONITOR: true, // ✅ Activé temporairement pour les tests D1-D5
}

/**
 * Beta users pour activation progressive
 * Ajouter les user IDs ici pour tester en production
 * 
 * Exemple :
 * export const BETA_USERS = [
 *   'uuid-user-1',
 *   'uuid-user-2',
 * ]
 */
export const BETA_USERS: string[] = [
  // Vide = désactivé pour tous
  // Pour activer pour tous : laisser vide ET mettre FEATURES à true
]

/**
 * Vérifie si une feature est activée pour un utilisateur
 */
export const isFeatureEnabled = (
  feature: keyof typeof FEATURES, 
  userId?: string
): boolean => {
  // Si feature désactivée globalement, retourner false
  if (!FEATURES[feature]) return false
  
  // Si pas de beta users définis, activer pour tous
  if (BETA_USERS.length === 0) return true
  
  // Sinon, activer seulement pour beta users
  return userId ? BETA_USERS.includes(userId) : false
}

/**
 * Configuration des limites de sécurité
 */
export const LIMITS = {
  MAX_REALTIME_CONNECTIONS: 3, // Maximum 3 connexions WebSocket
  MAX_RECONNECT_ATTEMPTS: 3, // Maximum 3 tentatives de reconnexion
  CIRCUIT_BREAKER_THRESHOLD: 5, // Ouvrir le circuit après 5 échecs
  CIRCUIT_BREAKER_TIMEOUT: 60000, // 1 minute avant de réessayer
  MAX_RENDERS_PER_10S: 100, // Maximum 100 re-renders en 10 secondes
  DEBOUNCE_DELAY: 500, // 500ms de debounce pour les invalidations
}
